import { render, staticRenderFns } from "./suggestionImpr.vue?vue&type=template&id=6879bd8c"
import script from "./suggestionImpr.vue?vue&type=script&lang=js"
export * from "./suggestionImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6879bd8c')) {
      api.createRecord('6879bd8c', component.options)
    } else {
      api.reload('6879bd8c', component.options)
    }
    module.hot.accept("./suggestionImpr.vue?vue&type=template&id=6879bd8c", function () {
      api.rerender('6879bd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionImpr.vue"
export default component.exports